import { render, staticRenderFns } from "./baseSearch.vue?vue&type=template&id=ef70b1c2"
import script from "./baseSearch.vue?vue&type=script&lang=js"
export * from "./baseSearch.vue?vue&type=script&lang=js"
import style0 from "./baseSearch.vue?vue&type=style&index=0&id=ef70b1c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports